import React from 'react'
import classes from './pose-img.module.sass'

const ThreePoseGrid = ({ items }) => (
  <div className={classes.poses3}>
    {items}
  </div>
)

export default ThreePoseGrid
